import { useEffect, useState } from "react";
import {
    getLateFeeConfig,
    saveLateFeeConfig,
} from "../../services/adminConfigService";
import { useUser } from "../../context/AuthContext";

import "./AdminConfig.css";

const GROUP_ID = "AABFXWN";

const LateFeeConfig = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const { user } = useUser();


    const [config, setConfig] = useState({
        groupId: GROUP_ID,
        isActive: false,
        lateFeeType: "FlatAmount",  
        lateFeePercent: 0,
        flatLateFeeAmount: null,
        isCompound: false,
    });

    const update = (key, value) =>
        setConfig((p) => ({ ...p, [key]: value }));

    /* ===== Fetch ===== */
    useEffect(() => {
        const load = async () => {
            try {
                const data = await getLateFeeConfig(GROUP_ID);


                // ✅ Map API (PascalCase) → React state (camelCase)
                setConfig({
                    groupId: data.GroupId ?? GROUP_ID,
                    isActive: Boolean(data.IsActive),
                    isCompound: Boolean(data.IsCompound),
                    lateFeeType: data.LateFeeType ?? "FlatAmount",
                    lateFeePercent: Number(data.LateFeePercent ?? 0),
                    flatLateFeeAmount:
                        data.FlatLateFeeAmount !== null &&
                            data.FlatLateFeeAmount !== undefined
                            ? Number(data.FlatLateFeeAmount)
                            : "",
                });
            } catch (err) {
                console.error("Failed to load late fee config", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);



    /* ===== Save ===== */
    const handleSave = async () => {
        const payload = {
            groupId: GROUP_ID,
            isActive: config.isActive,
            isCompound: config.isCompound,
            lateFeeType: config.lateFeeType,
            lateFeePercent:
                config.lateFeeType === "Percentage"
                    ? Number(config.lateFeePercent)
                    : null,
            flatLateFeeAmount:
                config.lateFeeType === "FlatAmount"
                    ? Number(config.flatLateFeeAmount)
                    : null,
        };

        try {
            setSaving(true);
            await saveLateFeeConfig(payload);
            alert("Late fee config saved");
        } catch (e) {
            alert(typeof e === "string" && e ? e : "Save failed");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <section className="config-card">
            <h3>Late Fee Configuration</h3>

            <label className="toggle">
                <input
                    type="checkbox"
                    checked={config.isActive}
                    onChange={(e) => update("isActive", e.target.checked)}
                />
                Enable Late Fee
            </label>

            {config.isActive && (
                <>
                    <div className="field">
                        <label>Late Fee Type</label>
                        <select
                            value={config.lateFeeType}
                            onChange={(e) =>
                                update("lateFeeType", e.target.value)
                            }
                        >
                            <option value="FlatAmount">Flat Amount</option>
                            <option value="Percentage">Percentage</option>
                        </select>
                    </div>

                    {config.lateFeeType === "FlatAmount" && (
                        <div className="field">
                            <label>Flat Amount</label>
                            <input
                                type="number"
                                value={config.flatLateFeeAmount ?? ""}
                                onChange={(e) =>
                                    update("flatLateFeeAmount", e.target.value)
                                }
                            />
                        </div>
                    )}

                    {config.lateFeeType === "Percentage" && (
                        <div className="field">
                            <label>Percentage (%)</label>
                            <input
                                type="number"
                                value={config.lateFeePercent}
                                onChange={(e) =>
                                    update("lateFeePercent", e.target.value)
                                }
                            />
                        </div>
                    )}

                    <label className="toggle">
                        <input
                            type="checkbox"
                            checked={config.isCompound}
                            onChange={(e) =>
                                update("isCompound", e.target.checked)
                            }
                        />
                        Compound Late Fee
                    </label>
                </>
            )}

            <button
                className="primary"
                onClick={handleSave}
                disabled={saving}
            >
                {saving ? "Saving..." : "Save"}
            </button>
        </section>
    );
};

export default LateFeeConfig;
